import React from 'react'

const CircleSVG = () => {
  return (
    <>
      <svg
        width='22'
        height='22'
        viewBox='0 0 32 32'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle cx='16' cy='16' r='16' fill='#DCD7FE' />
      </svg>
    </>
  )
}

export default CircleSVG
